export default "__VITE_ASSET__72HPsET9__"